import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { storageKeys } from '../../../../../stores/DebuggerStore';
import { ValueChanger } from '../Controls/ValueChanger';

import { LogJustErrorsButton } from './Buttons/LogJustErrorsButton';
import { LogToConsoleButton } from './Buttons/LogToConsoleButton';
import { LogToDevWindowButton } from './Buttons/LogToDevWindowButton';
import { SetDefaultsButton } from './Buttons/SetDefaultsButton';
import { SettingCheckboxes } from './SettingCheckboxes';
import {
  engineLogLevelCheckboxes,
  generalSettingsCheckboxes,
  uiLogLevelCheckboxes,
} from './utils';

import { getSimLogSize } from '../../../../../shared/utils/SimulcastLogger';
import { Wrapper } from './../Styles';
import { DisableClerkDebuggingButton } from './Buttons/DisableClerkDebuggingButton';
import { DisableLoggingButton } from './Buttons/DisableLoggingButton';
import { EnableClerkDebuggingButton } from './Buttons/EnableClerkDebuggingButton';
import { LogVerboseButton } from './Buttons/LogVerboseButton';
import { WatchModeButton } from './Buttons/WatchModeButton';
import {
  Buttons,
  CheckboxContainer,
  Container,
  InputContainer,
  SettingsContainer,
} from './Styles';

export const Settings = observer(() => {
  const {
    BidStore: {
      auction: { monitorChatOnly },
    },
    DebuggerStore: {
      // debuggerUpdated,
      engineLogLevel,
      maxLogStorageSize,
      maxMessageLength,
      setDebugItem,
      shouldDeleteOnBlockChange,
      shouldReadLogWhenConnected,
      shouldSendTimestampsToEngine,
      shouldSkipPingPongWhenConnected,
      shouldWriteLogToConsole,
      shouldWriteLogToDevWindow,
      shouldWriteLogWhenConnected,
      shouldWriteTimstampsToConsole,
      uiLogLevel,
    },
  } = useStores();

  const generalSettings = generalSettingsCheckboxes({
    storageKeys,
    store: {
      engineLogLevel,
      setDebugItem,
      shouldDeleteOnBlockChange,
      shouldReadLogWhenConnected,
      shouldSendTimestampsToEngine,
      shouldSkipPingPongWhenConnected,
      shouldWriteLogToConsole,
      shouldWriteLogToDevWindow,
      shouldWriteLogWhenConnected,
      shouldWriteTimstampsToConsole,
      uiLogLevel,
    },
  });

  const simLogSize = getSimLogSize();
  const uiLogLevelSettings = uiLogLevelCheckboxes({
    storageKeys,
    store: { setDebugItem, uiLogLevel },
  });

  const engineLogLevelSettings = engineLogLevelCheckboxes({
    storageKeys,
    store: { engineLogLevel, setDebugItem },
  });

  return (
    <Wrapper>
      <Container>
        <Buttons>
          <SetDefaultsButton />
          <DisableLoggingButton />
          <LogJustErrorsButton />
          <LogVerboseButton />
          <LogToConsoleButton />
          <LogToDevWindowButton />
        </Buttons>
        <SettingsContainer>
          <CheckboxContainer>
            <SettingCheckboxes
              controls={engineLogLevelSettings}
              direction="horizontal"
              group="engineLogLevel"
              groupLabel="Engine Log Level:"
              notImplemented
              // key={`engineLogLevel-settings-${debuggerUpdated}`}
            />
            <SettingCheckboxes
              controls={uiLogLevelSettings}
              direction="horizontal"
              group="uiLogLevel"
              groupLabel="UI Log Level:"
              // key={`uiLogLevel-settings-${debuggerUpdated}`}
            />
            <hr />
            <SettingCheckboxes
              controls={generalSettings}
              direction="vertical"
              group={null}
              // key={`general-settings-${debuggerUpdated}`}
            />
          </CheckboxContainer>
          <InputContainer>
            <ValueChanger
              incrementValue={200}
              label="Max Storage Size (KB)"
              maxValue={4000}
              minValue={200}
              onClick={(value) => {
                if (simLogSize < value) {
                  setDebugItem(storageKeys.maxLogStorageSizeInKb, value);
                }
              }}
              value={maxLogStorageSize}
            />
            <ValueChanger
              incrementValue={50}
              label="Max Message Size (Chars)"
              maxValue={500}
              minValue={50}
              onClick={(value) =>
                setDebugItem(storageKeys.maxMessageLength, value)
              }
              value={maxMessageLength}
            />
            {monitorChatOnly ? (
              <>
                <EnableClerkDebuggingButton />
                <DisableClerkDebuggingButton />
              </>
            ) : (
              <WatchModeButton />
            )}
          </InputContainer>
        </SettingsContainer>
      </Container>
    </Wrapper>
  );
});

export default Settings;
